<script>

    import {  shipmentStore } from '../stores'

    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

</script>

<div class="subtitle is-5">Paquete</div>

<DetailsCard>
    <DetailsFields>
        <DetailsField label="Ancho" value={`${$shipmentStore.order.package.width} cm`} />
        <DetailsField label="Alto" value={`${$shipmentStore.order.package.height} cm`} />
        <DetailsField label="Largo" value={`${$shipmentStore.order.package.length} cm`} />
        <DetailsField label="Peso" value={`${$shipmentStore.order.package.weight} kg`} />
        <DetailsField label="Volumétrico" value={`${$shipmentStore.order.package.volumetric} kg`} />
        <DetailsField label="Valor" value={`$${$shipmentStore.order.package.value}`} mono />
        <DetailsField label="Descripción" value={$shipmentStore.order.package.content} />
    </DetailsFields>
</DetailsCard>
